import { IframeHOCProps, withIframeDomain } from "./HistoricalPortfolioLink";

type RebalanceOrdersProps = {
  authToken: string;
  productId?: number;
  type?: "PRODUCT" | "COMBINED";
  userType?: string;
};

export const RebalanceOrders = withIframeDomain(RebalanceOrdersIFrame);

function RebalanceOrdersIFrame({
  domain,
  authToken,
  productId,
  type,
  userType,
}: RebalanceOrdersProps & IframeHOCProps) {
  const url = `${domain}/ordersReblance?id=${authToken}&productId=${productId}&type=${type}&userType=${userType}`;

  return (
    <div style={{ height: "85vh", width: "100%" }}>
      <iframe
        title={"Last Rebalance"}
        src={url}
        width={"100%"}
        height={"100%"}
      />
    </div>
  );
  // return userType === TRIAL_USER_TYPE ? (
  //   <></>
  // ) : (
  // <div style={{ height: "85vh", width: "100%" }}>
  //   <iframe title={"Last Rebalance"} src={url} width={"100%"} height={"100%"} />
  // </div>;
  // );
}
